module.exports = __webpack_public_path__ + "media/images/mobile/abouts/arrow-6470e496a05d31a7f26d3367e1aef46b.png";